import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoins: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCoins"><Path d="M14.885 7.23659C13.8464 5.02855 11.6017 3.5 9 3.5C5.41015 3.5 2.5 6.41015 2.5 10C2.5 13.4907 5.25154 16.3386 8.704 16.4934M21.5 14C21.5 17.5899 18.5899 20.5 15 20.5C11.4101 20.5 8.5 17.5899 8.5 14C8.5 10.4101 11.4101 7.5 15 7.5C18.5899 7.5 21.5 10.4101 21.5 14Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCoins;
